import {
  getClipParams,
  getAdjustedDirection,
} from '../../../../utils/animationsUtils';
import type {
  AnimationProperties,
  Direction,
  AnimationsKit,
} from '../../../../types';

const name = 'RevealIn';
const properties: AnimationProperties = { schema: {} };

const paramsMap = {
  top: { dx: 0, dy: -1, idx: 0 },
  right: { dx: 1, dy: 0, idx: 1 },
  bottom: { dx: 0, dy: 1, idx: 2 },
  left: { dx: -1, dy: 0, idx: 3 },
};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[],
  duration: number,
  delay: number,
  {
    direction = 'left',
    easing = 'cubicInOut',
    ...params
  }: {
    easing?: string;
    direction?: keyof typeof paramsMap;
  } = {},
) {
  const sequence = kit.sequence(params);

  elements.forEach((element) => {
    const compRect = kit.engine.getBoundingRect(element);
    const contentRect = kit.engine.getBoundingContentRect(element);

    const elementAngleInDeg = Number(
      kit.engine.getProperty(element, '--comp-rotate-z') || 0,
    );

    const adjDirection = getAdjustedDirection(
      paramsMap,
      direction,
      elementAngleInDeg,
    ) as keyof typeof paramsMap;

    const from = getClipParams(
      compRect,
      contentRect,
      adjDirection as Direction,
    );

    sequence.add(
      kit.animate('BaseClipPath', element, duration, delay, {
        from,
        ease: easing,
      }),
      0,
    );
  });

  return sequence.get();
}

export { name, properties, animate };
